window.clipboard = window.clipboard || {};

window.clipboard.copyText = async function (value) {
    try {
        await navigator.clipboard.writeText(value);
        return true;
    } catch {
        const area = document.createElement('textarea');
        area.value = value;
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.focus();
        area.select();
        let copied = false;
        try {
            copied = document.execCommand('copy');
        } catch {
            copied = false;
        }

        document.body.removeChild(area);
        return copied;
    }
};
